import { render, staticRenderFns } from "./CustomerDetailModal.vue?vue&type=template&id=4a43fee6&"
import script from "./CustomerDetailModal.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports